<div class="product-swiper-container">
  <div class="w-100 text-center mt-2 mb-2 d-none d-lg-block">
    <button mat-raised-button *ngIf="showZoom" class="zoom-icon" (click)="openZoom()" color="primary">
      <mat-icon class="ml-1">zoom_out_map</mat-icon>View Zoomed Image
    </button>
  </div>
  <div class="w-100 text-right mt-2 mb-2 d-lg-none" style="position: relative;">
    <button mat-raised-button *ngIf="showZoom" class="zoom-icon zoom-icon-mobile" (click)="openZoom()" color="primary" name="Zoom Image" title="Zoom Image" aria-label="Zoom Image">
      <mat-icon class="ml-1">zoom_in</mat-icon>
    </button>
  </div>
  <swiper-container #productSwiper init="false">
    <swiper-slide *ngFor="let slide of slides; let i = index">
      <div class="swiper-img-container">
        <picture  *ngIf="!slide.youTubeRef">
          <source [id]="'pdp-swipe-source' + i" [srcset]="slide.imgUrl + '.webp'" type="image/webp" />
          <img [id]="'pdp-swipe-img' + i" [src]="slide.imgUrl" [alt]="slide.alt">
        </picture>
        <youtube-player [id]="'pdp-swipe-youtube' + i" #youTubePlayer *ngIf="slide.youTubeRef" [videoId]="slide.youTubeRef" disablePlaceholder></youtube-player>
      </div>
    </swiper-slide>
  </swiper-container>
  <div *ngIf="slides?.length > 1" class="swiper-button-prev-product">
    <a aria-label="Previous" (click)="slidePrev()">
      <mat-icon color="warn">arrow_circle_left</mat-icon>
    </a>
  </div>
  <div *ngIf="slides?.length > 1" class="swiper-button-next-product">
    <a aria-label="Next" (click)="slideNext()">
      <mat-icon color="warn">arrow_circle_right</mat-icon>
    </a>
  </div>
</div>
<swiper-container #productThumbsSwiper init="false" class="mt-1 mb-1">
  <swiper-slide *ngFor="let slide of slides; let i = index" class="swiper-thumb-container">
    <img [id]="'pdp-swipe-thumb-' + i" *ngIf="slides?.length > 1 && !slide.youTubeRef" [src]="slide.imgUrl" [alt]="slide.alt" class="swiper-thumb">
    <div *ngIf="slides?.length > 1 && slide.youTubeRef" style="position: relative;">
      <img [id]="'pdp-swipe-thumb-' + i" [src]="'https://img.youtube.com/vi/' + slide.youTubeRef + '/default.jpg'" [alt]="slide.alt" class="swiper-thumb">
      <mat-icon class="play-icon" color="warn">play_circle</mat-icon>
    </div>
  </swiper-slide>
</swiper-container>
